import React from "react";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import { Close, Save } from "@mui/icons-material";
import { Container } from "@mui/material";
const PREFIX = "toolbarDefaultActions";

const classes = {
  buttonSpaces: `${PREFIX}-buttonSpaces`,
};

const StyledContainer = styled(Container)(({ theme }) => ({
  [`& .${classes.buttonSpaces}`]: {
    backgroundColor: "#424242",
    color: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: "rgba(66,66,66,0.7)",
      color: theme.palette.primary.main,
    },
    "&:not(:last-child)": {
      marginRight: "15px",
    },
  },
}));

export default function ToolbarDefaultActions(props) {
  return (
    <StyledContainer
      disableGutters
      style={{ display: "flex", flexDirection: "row" }}
    >
      {props.save && (
        <IconButton
          className={classes.buttonSpaces}
          onClick={props.save}
          size="large"
        >
          <Save />
        </IconButton>
      )}
      {props.cancel && (
        <IconButton
          className={classes.buttonSpaces}
          onClick={props.cancel}
          size="large"
        >
          <Close />
        </IconButton>
      )}
    </StyledContainer>
  );
}
